import * as React from 'react';
import { Alert } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { SizeGuideModalContainer } from '../../SizeGuideModal/SizeGuideModalContainer.js';
import '@grandvisionhq/analytics';
import 'classnames';
import '@grandvisionhq/elements';
import '@grandvisionhq/utils';
import '@swc/helpers';
import 'usehooks-ts';
import '../../../../VTO/context/VtoProvider.js';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import '../../../../../types/product.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import { FacetPicker } from '../components/FacetPicker.js';
import { FrameSizeFacet } from './FrameSizeFacet.js';
import { orderSizeFacets } from './helpers/order-size-facets.js';

const FacetPickerSize = ({ onPick , activeFacet , items: facetList , enableStockIndicator , notificationType , className , productType ,  })=>{
    const { getLabel  } = useIntl();
    const activeFacetTerm = activeFacet === null || activeFacet === void 0 ? void 0 : activeFacet.facetTerm;
    const iconName = notificationType === 'error' ? 'alert-circle' : 'info';
    const items = React.useMemo(()=>{
        return orderSizeFacets(facetList !== null && facetList !== void 0 ? facetList : []);
    }, [
        facetList
    ]);
    if (facetList.length === 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, /*#__PURE__*/ React.createElement(FacetPicker, {
        productType: productType,
        className: "facet-picker-size",
        itemComponent: FrameSizeFacet,
        items: items,
        onPick: onPick,
        title: getLabel('products.facets.frameSize.title'),
        activeFacet: activeFacet,
        showFacetName: false,
        enableStockIndicator: enableStockIndicator
    }), notificationType && !activeFacetTerm && /*#__PURE__*/ React.createElement(Alert, {
        type: notificationType,
        icon: iconName,
        message: getLabel('products.facets.frameSize.notification')
    }), /*#__PURE__*/ React.createElement(SizeGuideModalContainer, null));
};

export { FacetPickerSize };
//# sourceMappingURL=FacetPickerSize.js.map
